import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule} from "@angular/common/http";

import {LocationStrategy, PathLocationStrategy, registerLocaleData} from "@angular/common";
import localePl from '@angular/common/locales/pl';
import localePlExtra from '@angular/common/locales/extra/pl';

import {ErrorsHandler} from "./shared/errors-handler.service";
import {ToastrModule} from "ngx-toastr";
import {DeviceDetectorModule} from "ngx-device-detector";
import {LoginComponent} from './login/login.component';
import {SharedModule} from "./shared/shared.module";
import {BosCommonsModule, BosXsrfInterceptor, EnvironmentService} from 'bos-commons';
import { RemindPasswordComponent } from './remind-password/remind-password.component';
import {PreventDoubleSubmitModule} from "ngx-prevent-double-submission";
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { LogoutComponent } from './logout/logout.component';
import { LogoutIframeComponent } from './logout-iframe/logout-iframe.component';
import { FooterComponent } from './footer/footer.component';
import { CodeComponent } from './code/code.component';
import { PasswordExpiredComponent } from './password-expired/password-expired.component';
import { LogoComponent } from './logo/logo.component';
import { BackButtonComponent } from './back-button/back-button.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import {AdminModule} from './admin/admin.module';
import { VersionInfoComponent } from './version-info/version-info.component';
import { LinkViewComponent } from './link-view/link-view.component';
import { LinkComponent } from './link/link.component';
import {MatRadioModule} from "@angular/material/radio";
import { DomainSelectComponent } from './domain-select/domain-select.component';
import { LogoutCallbackComponent } from './logout-callback/logout-callback.component';
import { AboutComponent } from './about/about.component';
import { ExternalLoginSuccessComponent } from './external-login-success/external-login-success.component';

export const httpInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: BosXsrfInterceptor, multi: true},
];

registerLocaleData(localePl, 'pl-Pl', localePlExtra);
registerLocaleData(localePl, 'pl', localePlExtra);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RemindPasswordComponent,
    ResetPasswordComponent,
    LogoutComponent,
    LogoutIframeComponent,
    FooterComponent,
    CodeComponent,
    FooterComponent,
    PasswordExpiredComponent,
    LogoComponent,
    BackButtonComponent,
    AccessDeniedComponent,
    VersionInfoComponent,
    LinkViewComponent,
    LinkComponent,
    DomainSelectComponent,
    LogoutCallbackComponent,
    AboutComponent,
    ExternalLoginSuccessComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    HttpClientXsrfModule.withOptions({
      cookieName: 'XSRF-TOKEN',
      headerName: 'X-CSRF-TOKEN',
    }),
    ToastrModule.forRoot(
      {
        maxOpened: 5,
        autoDismiss: false,
        closeButton: false,
        tapToDismiss: true,
        newestOnTop: false,
        positionClass: 'toast-top-center',
        countDuplicates: true,
        preventDuplicates: true,
        timeOut: 5000,
      }),
    DeviceDetectorModule.forRoot(),
    BosCommonsModule,
    PreventDoubleSubmitModule.forRoot(),
    AdminModule,
    AppRoutingModule,
    MatRadioModule
  ],
  providers: [   {provide: LOCALE_ID, useValue: navigator.language + '' || 'pl-PL'},
    {provide: LocationStrategy, useClass: PathLocationStrategy},
    {provide: APP_INITIALIZER, useFactory: environmentFactory, deps: [EnvironmentService], multi: true},
    httpInterceptorProviders,
    {
      provide: ErrorHandler, useClass: ErrorsHandler
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function environmentFactory(environmentService: EnvironmentService) {
  return () => environmentService.loadDynamicEnvironment();
}
